import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=021627c6&scoped=true&"
import script from "./Money.vue?vue&type=script&lang=ts&"
export * from "./Money.vue?vue&type=script&lang=ts&"
import style0 from "./Money.vue?vue&type=style&index=0&id=021627c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021627c6",
  null
  
)

export default component.exports